import { render, staticRenderFns } from "./customFieldSelect.vue?vue&type=template&id=18f88b7e&scoped=true"
import script from "./customFieldSelect.vue?vue&type=script&lang=js"
export * from "./customFieldSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f88b7e",
  null
  
)

export default component.exports